import React, { useEffect, useMemo, useState } from "react";
import "./WhitelistedSender.css";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { Messante_URL } from "./apiConfig";

const PAGE_SIZE = 200;

export default function ViewWhitelistedTemplate({ ViewDLTAPIData = [] }) {

    const [contentSearch, setContentSearch] = useState("");
    const [senderSearch, setSenderSearch] = useState("");
    const [templateIdSearch, setTemplateIdSearch] = useState("");

    const [currentPage, setCurrentPage] = useState(1);
    const [isFullScreen, setIsFullScreen] = useState(false);

    const [ViewSenderAPIData, setViewSenderAPIData] = useState([]);
    const [showprogress, setshowprogress] = useState(false);

    const loginData = JSON.parse(
        sessionStorage.getItem("loginData")
    );

    const sessionusertype = loginData?.utype?.usertype;
    const sessionusername = loginData?.guiuserid;


    // =========================================================
    // API - GET DLT TEMPLATES
    // =========================================================

    const callViewAllSender = async () => {
        try {

            console.log("calling callViewAllSender");

            setshowprogress(true);

            const apiUrl =
                `${Messante_URL}/template?uid=${sessionusername}&activityBy=${sessionusername}`;

            const fetchOptions = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            };

            const response = await fetch(
                apiUrl,
                fetchOptions
            );

            const data = await response.json();

            setshowprogress(false);

            if (
                data?.status === "Success" ||
                data?.errorCode === "000"
            ) {

                const TemplateData =
                    Array.isArray(data?.templatelst)
                        ? data.templatelst
                        : [];

                console.log("TemplateData:", TemplateData)
                setViewSenderAPIData(TemplateData);

            } else {

                setViewSenderAPIData([]);

            }

        } catch (error) {

            console.error(
                "API Request Error:",
                error.message
            );

            setshowprogress(false);

            await Swal.fire({
                title: "API Request Error",
                html: error.message,
                icon: "error"
            });
        }
    };


    // =========================================================
    // LOAD DATA
    // =========================================================

    useEffect(() => {
        callViewAllSender();
    }, []);


    // =========================================================
    // DATA SOURCE
    // =========================================================

    /*
        If the API data is returned through ViewDLTAPIData,
        use that.

        Otherwise use the data fetched by callViewAllSender().
    */

    const templateData =
        ViewDLTAPIData?.length > 0
            ? ViewDLTAPIData
            : ViewSenderAPIData;


    // =========================================================
    // SEARCH
    // =========================================================

    const filteredData = useMemo(() => {

        const content =
            contentSearch
                .trim()
                .toLowerCase();

        const sender =
            senderSearch
                .trim()
                .toLowerCase();

        const templateId =
            templateIdSearch
                .trim()
                .toLowerCase();


        return templateData.filter((row) => {

            const contentMatch =
                !content ||
                String(row?.smsText || "")
                    .toLowerCase()
                    .includes(content);


            const senderMatch =
                !sender ||
                String(row?.sender || "")
                    .toLowerCase()
                    .includes(sender);


            const templateIdMatch =
                !templateId ||
                String(row?.smsTemplateID || "")
                    .toLowerCase()
                    .includes(templateId);


            return (
                contentMatch &&
                senderMatch &&
                templateIdMatch
            );

        });

    }, [
        templateData,
        contentSearch,
        senderSearch,
        templateIdSearch
    ]);


    // =========================================================
    // PAGINATION
    // =========================================================

    const totalPages = Math.max(
        1,
        Math.ceil(
            filteredData.length / PAGE_SIZE
        )
    );


    const validPage = Math.min(
        currentPage,
        totalPages
    );


    const startIndex =
        (validPage - 1) * PAGE_SIZE;


    const endIndex =
        startIndex + PAGE_SIZE;


    const currentPageData =
        filteredData.slice(
            startIndex,
            endIndex
        );


    // =========================================================
    // PAGE CHANGE
    // =========================================================

    const goToPreviousPage = () => {

        if (validPage > 1) {
            setCurrentPage(
                validPage - 1
            );
        }

    };


    const goToNextPage = () => {

        if (validPage < totalPages) {
            setCurrentPage(
                validPage + 1
            );
        }

    };


    // =========================================================
    // SEARCH CHANGE
    // =========================================================

    const handleContentSearch = (e) => {

        setContentSearch(
            e.target.value
        );

        setCurrentPage(1);
    };


    const handleSenderSearch = (e) => {

        setSenderSearch(
            e.target.value
        );

        setCurrentPage(1);
    };


    const handleTemplateIdSearch = (e) => {

        setTemplateIdSearch(
            e.target.value
        );

        setCurrentPage(1);
    };


    // =========================================================
    // CLEAR SEARCH
    // =========================================================

    const clearContentSearch = () => {

        setContentSearch("");
        setCurrentPage(1);

    };


    const clearSenderSearch = () => {

        setSenderSearch("");
        setCurrentPage(1);

    };


    const clearTemplateIdSearch = () => {

        setTemplateIdSearch("");
        setCurrentPage(1);

    };


    // =========================================================
    // RETURN
    // =========================================================

    return (

        <div
            className={
                isFullScreen
                    ? "whitelist-container fullscreen dlt-container"
                    : "whitelist-container dlt-container"
            }
        >

            {/* =================================================
                HEADER
            ================================================= */}

            <div className="whitelist-header">

                <div className="whitelist-title">
                    DLT Templates
                </div>


                <div className="whitelist-actions">

                    <Link
                        to="/templatewhitelist"
                        className="sender-submit-btn"
                        style={{
                            textDecoration: "none",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textTransform: "none"
                        }}
                    >

                        <i className="fa fa-reply" />

                        Back

                    </Link>

                </div>

            </div>


            {/* =================================================
                SEARCH SECTION
            ================================================= */}

            <div className="dlt-search-row">


                {/* CONTENT SEARCH */}

                <div className="dlt-content-search search-container">

                    <div className="search-icon">
                        <span>⌕</span>
                    </div>


                    <input
                        type="text"
                        placeholder="Search By Content...."
                        value={contentSearch}
                        onChange={
                            handleContentSearch
                        }
                    />


                    {contentSearch && (

                        <button
                            className="clear-search"
                            onClick={
                                clearContentSearch
                            }
                        >
                            ×
                        </button>

                    )}

                </div>


                {/* SENDER SEARCH */}

                <div className="dlt-normal-search">

                    <input
                        type="text"
                        placeholder="Search by Sender"
                        value={senderSearch}
                        onChange={
                            handleSenderSearch
                        }
                    />


                    {senderSearch && (

                        <button
                            className="dlt-clear-search"
                            onClick={
                                clearSenderSearch
                            }
                        >
                            ×
                        </button>

                    )}

                </div>


                {/* TEMPLATE ID SEARCH */}

                <div className="dlt-normal-search">

                    <input
                        type="text"
                        placeholder="Search by Template ID"
                        value={templateIdSearch}
                        onChange={
                            handleTemplateIdSearch
                        }
                    />


                    {templateIdSearch && (

                        <button
                            className="dlt-clear-search"
                            onClick={
                                clearTemplateIdSearch
                            }
                        >
                            ×
                        </button>

                    )}

                </div>

            </div>


            {/* =================================================
                TABLE
            ================================================= */}

            <div className="table-wrapper dlt-table-wrapper">

                <table className="sender-table dlt-table">

                    <thead>

                        <tr>

                            <th>
                                <div className="dlt-th-content">
                                    <span>User ID</span>
                                </div>
                            </th>


                            <th>
                                <div className="dlt-th-content">
                                    <span>Sender ID</span>
                                </div>
                            </th>


                            <th>
                                <div className="dlt-th-content">
                                    <span>Template ID</span>
                                </div>
                            </th>


                            <th>
                                <div className="dlt-th-content">
                                    <span>Template Name</span>
                                </div>
                            </th>


                            <th>
                                <div className="dlt-th-content">
                                    <span>Template Type</span>
                                </div>
                            </th>


                            <th>
                                <div className="dlt-th-content">
                                    <span>Created Date (IST)</span>
                                </div>
                            </th>


                            <th>
                                <div className="dlt-th-content">
                                    <span>Valid Till</span>
                                </div>
                            </th>


                            <th>
                                <div className="dlt-th-content">
                                    <span>Status</span>
                                </div>
                            </th>


                            <th>
                                <div className="dlt-th-content">
                                    <span>Template Content</span>
                                </div>
                            </th>

                        </tr>

                    </thead>


                    <tbody>

                        {currentPageData.length > 0 ? (

                            currentPageData.map(
                                (row, index) => (

                                    <tr
                                        key={
                                            row?.smsTemplateID ||
                                            index
                                        }
                                    >

                                        {/* USER ID */}

                                        <td>
                                            {row?.userID || "-"}
                                        </td>


                                        {/* SENDER */}

                                        <td>
                                            {row?.sender || "-"}
                                        </td>


                                        {/* TEMPLATE ID */}

                                        <td>
                                            {row?.smsTemplateID || "-"}
                                        </td>


                                        {/* TEMPLATE NAME */}

                                        <td
                                            title={
                                                row?.templateName ||
                                                "-"
                                            }
                                        >
                                            {
                                                row?.templateName ||
                                                "-"
                                            }
                                        </td>


                                        {/* TEMPLATE TYPE */}

                                        <td>
                                            {
                                                row?.templateType ||
                                                "-"
                                            }
                                        </td>


                                        {/* CREATED DATE */}

                                        <td>
                                            {
                                                row?.operatorCreatTime ||
                                                "-"
                                            }
                                        </td>


                                        {/* VALID DATE */}

                                        <td>
                                            {
                                                row?.validDate ||
                                                "-"
                                            }
                                        </td>


                                        {/* STATUS */}

                                        <td>

                                            <span
                                                className={
                                                    String(
                                                        row?.tstatus
                                                    ) === "1"
                                                        ? "status-active"
                                                        : "status-inactive"
                                                }
                                            >

                                                {
                                                    String(
                                                        row?.tstatus
                                                    ) === "1"
                                                        ? "Active"
                                                        : "Inactive"
                                                }

                                            </span>

                                        </td>


                                        {/* TEMPLATE CONTENT */}

                                        <td className="template-content-cell" style={{
        whiteSpace: "normal",
        overflow: "visible",
        textOverflow: "clip",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
        height: "auto",
        maxHeight: "none",
        verticalAlign: "top",
        minWidth: "400px"
    }}>
                                            {row?.smsText || "-"}
                                        </td>

                                    </tr>

                                )

                            )

                        ) : (

                            <tr>

                                <td
                                    colSpan="9"
                                    className="no-data"
                                >
                                    No DLT Templates found
                                </td>

                            </tr>

                        )}

                    </tbody>

                </table>

            </div>


            {/* =================================================
                FOOTER
            ================================================= */}

            <div className="dlt-footer">

                <div className="table-footer">

                    Showing{" "}

                    <b>
                        {
                            filteredData.length === 0
                                ? 0
                                : startIndex + 1
                        }
                    </b>

                    {" "}to{" "}

                    <b>
                        {
                            Math.min(
                                endIndex,
                                filteredData.length
                            )
                        }
                    </b>

                    {" "}of{" "}

                    <b>
                        {filteredData.length}
                    </b>

                    {" "}results

                </div>


                {/* PAGINATION */}

                <div className="pagination">

                    <button
                        className="pagination-btn"
                        disabled={
                            validPage === 1
                        }
                        onClick={
                            goToPreviousPage
                        }
                    >
                        ‹
                    </button>


                    <button
                        className="pagination-page"
                    >
                        {validPage}
                    </button>


                    <button
                        className="pagination-btn"
                        disabled={
                            validPage >= totalPages
                        }
                        onClick={
                            goToNextPage
                        }
                    >
                        ›
                    </button>

                </div>

            </div>

        </div>
    );
}